var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { palette } from '@/theme/palette';
import { linearProgressClasses } from '@mui/material';
import { Progress } from 'hx-progress';
export function StyledProgress(props) {
    var _a;
    return (_jsx(Progress, __assign({ sx: (_a = {},
            _a["& .".concat(linearProgressClasses.bar)] = {
                backgroundColor: palette.common.black,
            },
            _a["&.".concat(linearProgressClasses.colorPrimary)] = {
                backgroundColor: '#CFD4D7',
            },
            _a) }, props)));
}
